import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Box } from "@material-ui/core";
import Navbar from "./Navbar";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    color: "white",
    fontSize: "1.5rem",
  },
  timeLine: {
    position: "relative",
    padding: "1rem",
    margin: "0 auto",
    "&:before": {
      content: "''",
      position: "absolute",
      height: "100%",
      border: "1px solid tan",
      right: "40px",
      top: "1vh",
    },
    "&:after": {
      content: "''",
      display: "table",
      clear: "both",
    },
    [theme.breakpoints.up("md")]: {
      padding: "2rem",
      "&:before": {
        left: "calc(50% - 1px)",
        right: "auto",
      },
    },
  },
  timeLineItem: {
    padding: "1rem",
    borderBottom: "2px solid tan",
    position: "relative",
    margin: "1rem 3rem 1rem 1rem",
    clear: "both",
    "&:after": {
      content: "''",
      position: "absolute",
    },
    "&:before": {
      content: "''",
      position: "absolute",
      right: "-0.625rem",
      top: "calc(50% - 5px)",
      borderStyle: "solid",
      borderColor: "#f7550e #f7550e transparent transparent",
      borderWidth: "0.625rem",
      transform: "rotate(45deg)",
    },
    [theme.breakpoints.up("md")]: {
      width: "44%",
      margin: "1rem",
      "&:nth-of-type(2n)": {
        float: "right",
        margin: "1rem",
        borderColor: "tan",
      },
      "&:nth-of-type(2n):before": {
        right: "auto",
        left: "-0.625rem",
        borderColor: "transparent transparent #f7550e #f7550e ",
      },
    },
  },
  timeLineYear: {
    textAlign: "center",
    maxWidth: "9.375rem",
    margin: "0 3rem 0 auto",
    fontSize: "1.8rem",
    backgroundColor: "#f7550e",
    color: "white",
    lineHeight: 1,
    padding: "0.5rem 0 1rem",
    "&:before": {
      display: "none",
    },
    [theme.breakpoints.up("md")]: {
      textAlign: "center",
      margin: "0 auto",
      "&:nth-of-type(2n)": {
        float: "none",
        margin: "0 auto",
      },
      "&:nth-of-type(2n):before": {
        display: "none",
      },
    },
  },
  heading: {
    color: "#f7550e",
    paddingBottom: "2rem",
    paddingTop: "5rem",
    textTransform: "uppercase",
    fontSize: "1.2rem",
  },
  subheading: {
    color: "white",
    padding: "0",
    textTransform: "uppercase",
  },
}));

const WorkExperience = () => {
  const classes = useStyles();
  return (
    <>
      <Navbar />
      <Box component="header" className={classes.mainContainer}>
        <Typography varient="h4" align="center" className={classes.heading}>
          Working Experience
        </Typography>

        <Box component="div" className={classes.timeLine}>
          <Typography
            varient="h5"
            className={`${classes.timeLineYear} ${classes.timeLineItem}`}
          >
            2020
          </Typography>
          <Box component="div" className={classes.timeLineItem}>
            <Typography
              varient="h5"
              align="center"
              className={classes.subheading}
            >
              Web Developer Intern
            </Typography>

            <Typography
              varient="body1"
              align="center"
              style={{ color: "#f7550e" }}
            >
              Olcademy | 7 September 2020 - 7 December 2020
            </Typography>
            <Typography
              varient="subtitle"
              align="center"
              style={{ color: "tan" }}
            >
              • Joined as Web Development Intern in the Tech Center of
              Excellence Team.
              <br />• Initiated and Contributed in the Major ongoing Project's
              Backend part using Node.js, MongoDB, MySQL, Neo4j.
              <br /> • Acknowledged as Star Intern for month November 2020
            </Typography>
          </Box>
          <Box component="div" className={classes.timeLineItem}>
            <Typography
              varient="h5"
              align="center"
              className={classes.subheading}
            >
              FrontEnd Developer Intern
            </Typography>

            <Typography
              varient="body1"
              align="center"
              style={{ color: "#f7550e" }}
            >
              GirlsScript India | 17 September 2020 - 17 December 2020
            </Typography>
            <Typography
              varient="subtitle"
              align="center"
              style={{ color: "tan" }}
            >
              • Selected as participant for Girls Script Summer of Code 2020
              Extended.• <br />
              Contributed in the Open Source Project of "Feminist Bible" as
              Frontend Developer using React.js, Next.js & Sass.
            </Typography>
          </Box>
        </Box>
        <Typography varient="h4" align="center" className={classes.heading}>
          Volunteering Experience
        </Typography>
        <Box component="div" className={classes.timeLine}>
          <Typography
            varient="h5"
            className={`${classes.timeLineYear} ${classes.timeLineItem}`}
          >
            2020
          </Typography>
          <Box component="div" className={classes.timeLineItem}>
            <Typography
              varient="h5"
              align="center"
              className={classes.subheading}
            >
              President
            </Typography>

            <Typography
              varient="body1"
              align="center"
              style={{ color: "#f7550e" }}
            >
              Avant-Garde ADGITM | 12 September 2020 - present
            </Typography>
            <Typography
              varient="subtitle"
              align="center"
              style={{ color: "tan" }}
            >
              Leading "The Official Fine Arts Society" of my college which is
              also recognised as one of the most active student cultural club.
            </Typography>
          </Box>
          <Typography
            varient="h5"
            className={`${classes.timeLineYear} ${classes.timeLineItem}`}
          >
            2019
          </Typography>
          <Box component="div" className={classes.timeLineItem}>
            <Typography
              varient="h5"
              align="center"
              className={classes.subheading}
            >
              Project Head - NOHA
            </Typography>

            <Typography
              varient="body1"
              align="center"
              style={{ color: "#f7550e" }}
            >
              Enactus ADGITM | April 2019 - August 2020
            </Typography>
            <Typography
              varient="subtitle"
              align="center"
              style={{ color: "tan" }}
            >
              The project was aimed to design hand painted mobile covers and
              also to reuse/recyle them. Under this project, I led a team of 25+
              people and created 13 underprivileged women entrepreneurs. In
              september 2019 Project was featured at Enactus World Cup, San
              Jose, California.
              <br />
              <br />
              Along with leading the project I headed the Marketing & Campaign
              Department from 2019-2020 and Actively volunteered for the Enactus
              National Symposium and Competition 2019 from june 2019 to july
              2019.
            </Typography>
          </Box>
          <Typography
            varient="h5"
            className={`${classes.timeLineYear} ${classes.timeLineItem}`}
          >
            2018
          </Typography>
          <Box component="div" className={classes.timeLineItem}>
            <Typography
              varient="h5"
              align="center"
              className={classes.subheading}
            >
              Coordinator of Volunteers
            </Typography>

            <Typography
              varient="body1"
              align="center"
              style={{ color: "#f7550e" }}
            >
              Share A Book India Association | September 2018 - March 2019
            </Typography>
            <Typography
              varient="subtitle"
              align="center"
              style={{ color: "tan" }}
            >
              Taught basic english & grammar to school children of SRA public
              School Noida and led a team 5 volunteers for Library Development
              Program in the school.
              <br />
              <br />• Acknowledged as Best Volunteer of the Month in march 2019
              and also got featured in their monthly newsletter - Hues.
            </Typography>
          </Box>
          <Typography
            varient="h5"
            className={`${classes.timeLineYear} ${classes.timeLineItem}`}
          >
            2017
          </Typography>
          <Box component="div" className={classes.timeLineItem}>
            <Typography
              varient="h5"
              align="center"
              className={classes.subheading}
            >
              Volunteer
            </Typography>

            <Typography
              varient="body1"
              align="center"
              style={{ color: "#f7550e" }}
            >
              Indian Pollution Control Association | April 2016 - February 2017
            </Typography>
            <Typography
              varient="subtitle"
              align="center"
              style={{ color: "tan" }}
            >
              Volunteered in Project CHAMP(Clean & Healthy Air Management
              Program) in collaboration with National Science Congress which
              aimed to create awareness for air pollution and its control
              measures.
              <br />
              <br />• Received Best Awareness Team Award of Delhi from National
              Science Congress in 2017 under Project CHAMP.
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default WorkExperience;
